<template>
  <div class="leaflet-map leaflet-map--map">
    <div ref="map" :id="'leaflet-map-' + _uid" style="width: 100%; height: 100%"></div>
    <div class="leaflet-map--map__message" v-if="message !== null">
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import gmapsInit from "../../geocoder/gmaps";

export default {
  name: "GoogleMap",
  async mounted() {
    try {
      const google = await gmapsInit();
      this.geocoder = new google.maps.Geocoder();
      this.latlng = new google.maps.LatLng(48.140499, 11.53506);

      this.onUpdateGeoCode();
    } catch (error) {
      window.app.$helpers.logger(error);
    }
  },
  props: {
    zoom: {
      type: Number,
      default: 12
    },
    address: {
      type: String,
      default: ""
    },
    lat: {
      type: [String, Number],
      default: ""
    },
    lon: {
      type: [String, Number],
      default: ""
    },
    resize: {
      type: Boolean,
      default: false
    },
    panControl: {
      type: Boolean,
      default: false
    },
    zoomControl: {
      type: Boolean,
      default: false
    },
    useFitBounds: {
        type: Boolean,
        default: true
    }
  },

  data() {
    return {
      latlng: null,
      map: null,
      geocoder: null,
      marker: null,
      message: null,
      numOfTriesLimit: 2,
      numOfTries: 0,
      pin: "/assets/img/leaflet/marker-icon-red.svg"
    };
  },

  watch: {
    address: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.onUpdateGeoCode();
      }
    }
  },

  methods: {
    retryUpdateGeoCode: _.debounce(function() {
      this.onUpdateGeoCode();
      this.numOfTries++;
    }, 1000),

    onUpdateGeoCode: _.debounce(function() {
      if (this.address.trim() === "") {
        this.onUpdateNoAddress(this.$t("form.project.maps.no_valid_address"));
        return;
      }

      this.geocoder.geocode({ address: this.address.trim() }, (results, status) => {
        if (status !== "OK" || !results[0]) {
          if (this.numOfTriesLimit <= this.numOfTries) {
            this.onUpdateNoAddress(
              this.$t("form.project.maps.no_valid_location", {
                address: this.address.trim()
              })
            );
            window.app.$helpers.logger(status);
            this.numOfTries = 0;
          } else {
            // No Result, let's try again
            this.retryUpdateGeoCode();
          }

          return;
        }

        // We have a result! Move on!
        this.removeMap(); // reset map

        const mapOptions = {
          zoom: this.zoom,
          center: this.latlng,
          disableDefaultUI: true,
          panControl: this.panControl,
          zoomControl: this.zoomControl,
          mapTypeControl: false,
          streetViewControl: false,
          scrollwheel: false,
          mapTypeId: "roadmap"
        };

        if (!this.$refs.map) {
          // this.$helpers.logger('map reference not available anymore (Vue component unmounted)', this.$refs.map)
          return
        }

        this.map = new google.maps.Map(this.$refs.map, mapOptions);
        this.map.setCenter(results[0].geometry.location);
        
        if (this.useFitBounds) {
            this.map.fitBounds(results[0].geometry.viewport);
        }
  
        this.numOfTries = 0;
        this.message = null;

        this.marker = new google.maps.Marker({
          map: this.map,
          icon: this.pin,
          position: results[0].geometry.location
        });

        this.sendMarker(
          results[0].geometry.location.lat(),
          results[0].geometry.location.lng()
        );
      });
    }, 1000),

    onUpdateNoAddress: function(message) {
      this.message = message;
      this.$emit("noAddressFound", true);
    },

    removeMap: function() {
      this.map = null;
    },

    sendMarker: function(lat, lng) {
      let sendGeo = {
        lat: lat,
        lng: lng
      };

      this.$emit("marker", sendGeo);
    }
  }
};
</script>
